export default "__VITE_ASSET__CTsCge8A__"